'use client';

import {RedirectModal} from '@/components/molecules';
import {getStaticAssetPath} from '@/lib/utils/assets';
import {RedeemPinType} from '@/types';
import {useMessages} from '@epic-mw/i18n';

export type RedirectModalFactoryProps = {
	isLoading?: boolean;
	pinType?: RedeemPinType;
	redirectTo: string;
	onCloseAction?: () => void;
};

export const RedirectModalFactory = ({
	pinType,
	isLoading,
	redirectTo,
	onCloseAction
}: RedirectModalFactoryProps) => {
	const messages = useMessages();
	switch (pinType) {
		case 'VBUCKS': {
			return (
				<RedirectModal
					open
					onClose={onCloseAction}
					isLoading={isLoading}
					pinType={pinType}
					redirectTo={redirectTo}
					imgSrc={getStaticAssetPath('fortnite-vbucks-thumbnail.png')}
					title={messages['epic.app.modal.title.vbucks']}
					desc={messages['epic.app.modal.desc.vbucks']}
				/>
			);
		}

		default: {
			return null;
		}
	}
};
